import React from 'react';
import { MMediaSelector } from '../MMediaSelector/index';
import { MMediaSelectorMediaType } from '../MMediaSelector/MMediaSelector.types';
import * as Styled from './MMediaBorder.styles';
import {
  MMediaBorderAspectRatio,
  MMediaBorderProps,
  MMediaBorderStrokeWidth,
} from '../MMediaBorder/MMediaBorder.types';

const COMPONENT_NAME = 'm-web-ui-kit-MMediaBorder';
const TEST_ID = 'web-ui-kit-MMediaBorder';

export const MMediaBorder: React.FC<MMediaBorderProps> = ({
  aspectRatio = MMediaBorderAspectRatio.TwoThree,
  mediaType = MMediaSelectorMediaType.Image,
  strokeWidth = MMediaBorderStrokeWidth.None,
  mMediaSelector,
  className,
  ...rest
}) => {
  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={className}
      $aspectRatio={aspectRatio}
      $strokeWidth={strokeWidth}
      {...rest}
    >
      <MMediaSelector mediaType={mediaType} {...mMediaSelector} />
    </Styled.Wrapper>
  );
};

export * from '../MMediaBorder/MMediaBorder.types';
